import React from "react";
import { Box, Heading, Text, VStack, Link as ChakraLink } from "@chakra-ui/react";
import AppLayout from "../components/layout/AppLayout";

const ContactSupport = () => {
  return (
    <AppLayout>
      <Box
        w="100%"
        maxW="800px"
        mx="auto"
        mt={10}
        p={8}
        bg="white"
        borderRadius="lg"
        boxShadow="md"
        border="1px solid #E2E8F0"
      >
        <VStack spacing={6} align="start">
          <Heading color="#1C4C3F">Contact Support</Heading>

          <Text fontSize="lg" color="gray.700">
            Need help with ShelfKey? Whether it’s account issues, billing questions,
            or something not working as expected, you can reach us anytime at:
          </Text>

          <Box
            bg="#F7F5EB"
            borderRadius="md"
            p={6}
            w="100%"
            border="1px solid #D4D0C5"
          >
            <Text fontWeight="bold" color="#1C4C3F" mb={2}>
              Email Support
            </Text>

            <ChakraLink
              href="mailto:hello@shelfkey.co"
              color="#1C4C3F"
              fontSize="lg"
              fontWeight="semibold"
              _hover={{ textDecoration: "underline" }}
            >
              hello@shelfkey.co
            </ChakraLink>

            <Text color="gray.600" mt={3}>
              We typically respond within 24–48 hours.
            </Text>
          </Box>

          <Text color="gray.500" fontSize="sm">
            If you’re reporting a bug, screenshots and a short description of what you
            were doing right before the issue appeared are super helpful.
          </Text>
        </VStack>
      </Box>
    </AppLayout>
  );
};

export default ContactSupport;
